export const INDICADORES_SORT_OPTIONS = [
  { label: 'Relevância', value: '' },
  { label: 'Nome do indicador (A-Z)', value: 'indicador ASC' },
  { label: 'Nome do indicador (Z-A)', value: 'indicador DESC' }
];

/** Retorna apenas uma ordenação disponível para a listagem de indicadores. */
export function sanitizeIndicadoresSort(pSort) {
  return INDICADORES_SORT_OPTIONS.some(pOption => pOption.value === pSort) ? pSort : '';
}

/** Monta a ordenação enviada à API com desempates estáveis. */
export function resolveIndicadoresSort(pSort, pHasSearch) {
  const xSort = sanitizeIndicadoresSort(pSort);

  if (xSort) {
    return `${xSort}, relevancia DESC`;
  }

  return pHasSearch
    ? 'relevancia DESC, __mr__ DESC, indicador ASC'
    : 'relevancia DESC, indicador ASC';
}
